import React, { useEffect } from "react";
import {useDispatch, useSelector} from "react-redux";
import Style from "./mobileHeader.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageMenu from "./languageMenu";
import ArrowLeft from "../common/assets/arrow-left.svg";
import BeppoLogo from "../common/assets/beppo-logo-119x47.svg";
import { useAvailableLanguages } from "../util/internationalization";
import {RootState} from "../reducers";


interface MobileHeaderProps {
  logoHeader: boolean;
  arrowVisible: boolean;
}

const MobileHeader = (props: MobileHeaderProps) => {
  const [openMenu, setOpenMenu] = useState(false);
  const history = useHistory();
  const availableLanguages = useAvailableLanguages();
  const ticket = useSelector((state: RootState) => state.ticket.ticket);

  const menu = () => {
    setOpenMenu(!openMenu);
  };

  const changeRoute = (path: string) => {
    history.push(path);
  };

  useEffect(() => {
      const savedLanguage = localStorage.getItem("beppoSelectedLanguage") || i18n.language;

      if (!availableLanguages.includes(savedLanguage)) {
        const defaultLanguage = availableLanguages[0];
        i18n.changeLanguage(defaultLanguage);
        changeLanguageLabel(defaultLanguage.toUpperCase());
        localStorage.setItem("beppoSelectedLanguage", defaultLanguage);
      }
    }, [ticket]);

  const closeMenu = () => {
    setOpenMenu(false);
  };
  const changeLanguageLabel = (label: string) => {
    setLanguage(label);
  };

  const { i18n } = useTranslation();

  const [language, setLanguage] = useState(i18n.language.toUpperCase());

  const renderContent = () => {
    if (props.logoHeader) {
      return (
        <div className={Style.headerContainerWithLogo}>
          <div className={Style.headerContainerWithLogo__imgContainer}>
            <img
              src={BeppoLogo}
              id="beppoLogo"
              alt="beppo-logo"
              width={"100"}
            />
          </div>
          <div onClick={menu} className={Style.languageSwitchContainer}>
            <div className={Style.languageSwitchContainer__currentLanguage}>
              <FontAwesomeIcon icon={openMenu ? faAngleUp : faAngleDown} />
              <div>{language}</div>
            </div>
            {openMenu ? (
              <LanguageMenu
                closeMenu={closeMenu}
                changeLanguageLabel={changeLanguageLabel}
                availableLanguages={availableLanguages}
              />
            ) : null}
          </div>
        </div>
      );
    }
    return (
      <div className={Style.headerContainer}>
        {props.arrowVisible ? (
          <div
            onClick={() =>
              changeRoute(
                window.location.href.includes("/ticket-details")
                  ? "/tickets"
                  : "/ticket-details"
              )
            }
            className={Style.headerContainer__arrowContainer}
          >
            <img src={ArrowLeft} alt="leftArrow" />
          </div>
        ) : (
          <div></div>
        )}
        <div onClick={menu} className={Style.languageSwitchContainer}>
          <div className={Style.languageSwitchContainer__currentLanguage}>
            <FontAwesomeIcon icon={openMenu ? faAngleUp : faAngleDown} />
            <div>{language}</div>
          </div>
          {openMenu && (
            <LanguageMenu
              closeMenu={closeMenu}
              changeLanguageLabel={changeLanguageLabel}
                availableLanguages={availableLanguages}
            />
          )}
        </div>
      </div>
    );
  };
  return renderContent();
};

MobileHeader.defaultProps = {
  arrowVisible: false,
  logoHeader: false,
};
export default MobileHeader;
